import { TransformInt } from '../../../shared/decorators/transform-int.decorator';

import { CreateAssetReservationDto } from './create-asset-reservation.dto';

/**
 * Update asset reservation DTO
 */
export class UpdateAssetReservationDto extends CreateAssetReservationDto {
	@TransformInt()
	id!: number;
}
